import { call, put, takeLatest } from "redux-saga/effects";

import {
  getTransactionInfoSuccess,
  getTransactionInfoFailure,
} from "./TransactionInfo.actions";
import { TransactionInfoService } from "./TransactionInfo.store";

function* getTransactionInfoSaga(args) {
  try {
    const transactionInfoService = new TransactionInfoService();
    const data = yield call(transactionInfoService.fetchTransactionInfo, args);
    yield put(getTransactionInfoSuccess(data));
  } catch (error) {
    yield put(getTransactionInfoFailure(error));
  }
}

export function* transactionInfoSagas() {
  const GET_TRANSACTIONINFO = "GET_TRANSACTIONINFO";
  yield takeLatest(GET_TRANSACTIONINFO, getTransactionInfoSaga);
}
